import { render, staticRenderFns } from "./CardRequirementsComponent.vue?vue&type=template&id=0f455006&"
import script from "./CardRequirementsComponent.vue?vue&type=script&lang=ts&"
export * from "./CardRequirementsComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports